import React, { useState } from "react";
import { DotLegalMultiSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCertificationsQuery } from "../../../common/hooks/useSelectableItemQueries.ts";
import CertificationDialog from "../../../masterData/certification/certificationDialog/CertificationDialog.tsx";

export interface SystemCertificationsFieldProps {
    certifications: Array<string>;
    onChange: (certifications: Array<string>) => void;
    readOnly?: boolean;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function SystemCertificationsField(props: SystemCertificationsFieldProps) {
    const { translateString } = useTranslation();
    const certificationsQuery = useCertificationsQuery(!props.isPreview);
    const [showAddDialog, setShowAddDialog] = useState(false);
    const [typedCertification, setTypedCertification] = useState("");

    const onSaveCertification = (response: any) => {
        const temp = [...props.certifications];
        temp.push(response.id);
        props.onChange(temp);
        certificationsQuery.refetch();
        setShowAddDialog(false);
    };

    return (
        <>
            <DotLegalMultiSelect
                isLoading={certificationsQuery.isLoading && !props.readOnly}
                options={certificationsQuery.data}
                chosenOptions={props.certifications}
                onChange={props.readOnly ? () => {} : (certifications) => props.onChange(certifications)}
                placeholder={translateString("certification")}
                label={translateString("certification")}
                noOptionsLabel={translateString("noOptions")}
                disabled={props.disabled}
                errorText={props.errorText}
                toolTipText={translateString("systemCertificationTooltip")}
            />

            {showAddDialog && !props.readOnly && (
                <CertificationDialog
                    onDialogClose={() => setShowAddDialog(false)}
                    onCertificationSaved={onSaveCertification}
                    selectedCertification={{ name: typedCertification, description: "" }}
                />
            )}
        </>
    );
}

export default SystemCertificationsField;
